import React, { useState, useEffect } from 'react';
import { Close } from '@johnlewispartnership/wtr-style-dictionary/icons/react/Actions';
import { userAgent } from 'client/utils/user-agent';
import { getCookie, setCookie } from 'utils/cookie';
import { addYears } from 'utils/date';
import { COOKIE_APP_BANNER_DISMISS } from 'constants/cookies';
import AppLogo from './AppLogo';
import styles from './AppBanner.module.scss';

const shouldShowBanner = () => {
  const { os = { family: '' }, name, ua = '' } = userAgent();
  const { family } = os;

  const isAndroid = family === 'Android';

  const showBanner =
    !getCookie(COOKIE_APP_BANNER_DISMISS) &&
    !ua?.includes('MobileApp/') && // [BM]: App is being consumed via a web-view
    (isAndroid || (family === 'iOS' && name !== 'Safari'));

  return { showBanner, isAndroid };
};

export const AppBanner = () => {
  const [show, setShow] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const { showBanner, isAndroid: androidDevice } = shouldShowBanner();
    setShow(showBanner);
    setIsAndroid(androidDevice);
  }, []);

  const handleClose = () => {
    setCookie(COOKIE_APP_BANNER_DISMISS, '1', { expires: addYears(new Date(), 1) });
    setShow(false);
  };

  if (show) {
    return (
      <div id="app-banner" className={styles.appBanner} data-testid="app-banner">
        <div className={styles.close}>
          <button
            data-test="close"
            onClick={handleClose}
            type="button"
            aria-label="Close option to install Waitrose app"
          >
            <Close size="xsmall" />
          </button>
        </div>

        <div className={styles.icon}>
          <AppLogo />
        </div>

        <dl className={styles.info}>
          <div className={styles.appName}>
            <dt>App name</dt>
            <dd>Waitrose &amp; Partners</dd>
          </div>
          <div>
            <dt>App developer</dt>
            <dd>Waitrose {isAndroid ? 'Ltd' : 'Limited'}</dd>
          </div>
          <div>
            <dt>How to download</dt>
            <dd>{isAndroid ? 'FREE - On Google Play' : 'GET - On the App Store'}</dd>
          </div>
        </dl>
        <div className={styles.openLink}>
          <a
            href={
              isAndroid
                ? 'https://play.google.com/store/apps/details?id=com.waitrose.groceries'
                : 'https://apps.apple.com/gb/app/waitrose-partners/id1346064128'
            }
          >
            View
          </a>
        </div>
      </div>
    );
  }
  return null;
};
